import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import EmailSender from "./Components/EmailSender";
import Home from "./Components/Home";
import Navbar from "./Components/Navbar";
import SignUpForm from "./Components/SignUpForm";
import Datasend from "./Components/Datasend";
import Login from "./Components/Login";
import { AuthProvider } from "./Contexts/AuthContext";
import EmailLogin from "./Components/EmailLogin";
import ResetEmailPassword from "./Components/ResetEmailPassword";
import EmailChange from "./Components/EmailChange";
import Logout from "./Components/Logout";
import MemberList from "./Components/MemberList";
// import RegistEmailSender from "./Components/EmailComponents/RegistEmailSender";
import { MemberProvider } from "Contexts/MemberContext";
import MemberInfo from "./Components/MemberInfo";
import EmailSenderSelect from "./Components/EmailSenderSelect";
import Management from "./Components/Management";
// import EventCreate from "./Components/EventCreate";
import { EventProvider } from "./Contexts/EventContext";
import EventList from "./Components/EventList";
import { EventMembersProvider } from "./Contexts/EventMembersContext";
import EventSelect from "./Components/EventSelect";
import EventInfo from "./Components/EventInfo";
import EventDetail from "./Components/EventDetail";
import Calendar from "./Components/Calendar";
import EventCancel from "./Components/EventCancel";
import Links from "./Components/Links";
import Testdayo from "./Components/Testdayo";
import ParticipantEmaiSender from "./Components/ParticipantEmaiSender";
import SentEmails from "./Components/SentEmails";
import BackUpImport from "./utils/BackUpImport";
import JsonToCsv from "./utils/JsonToCsv";
import TennisOff from "./Components/TennisOff";
import Step1 from "./Components/StepSubmit/Step1";
import Step2 from "./Components/StepSubmit/Step2";
import Step3 from "./Components/StepSubmit/Step3";
import FinalSubmit from "./Components/StepSubmit/FinalSubmit";
// import MemberList from "./Components/MemberList";
import MemberCreate from "./Components/MemberCreate";
import MemberDetail from "./Components/MemberDetail";
import MemberDetailConfirm from "./Components/MemberDetailConfirm";
import CreatePost from "./Components/CreatePost";
import PostList from "./Components/PostList";
import Doubles from "./Components/Doubles";
import CircleInfo from "./Components/CircleInfo";
import CreateCircleInfo from "./Components/CreateCircleInfo";
import AboutUs from "./Components/AboutUs";

function App() {
  return (
    <Router>
      {" "}
      <AuthProvider>
        <EventMembersProvider>
          <EventProvider>
            <MemberProvider>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="management" element={<Management />} />
                <Route path="aboutus" element={<AboutUs />} />
                <Route path="backupimport" element={<BackUpImport />} />
                <Route path="jsontocsv" element={<JsonToCsv />} />
                <Route path="login" element={<Login />} />
                <Route path="logout" element={<Logout />} />
                <Route path="emaillogin" element={<EmailLogin />} />{" "}
                <Route path="links" element={<Links />} />{" "}
                <Route path="circleinfo" element={<CircleInfo />} />{" "}
                <Route path="circleinfo/:eventState" element={<CircleInfo />} />{" "}
                <Route path="createcircleinfo" element={<CreateCircleInfo />} />{" "}
                <Route
                  path="createcircleinfo/:circleId/:eventState"
                  element={<CreateCircleInfo />}
                />{" "}
                <Route path="tennisoff" element={<TennisOff />} />{" "}
                <Route path="membercreate" element={<MemberCreate />} />
                <Route path="membercreate/:id" element={<MemberCreate />} />
                {/* <Route path="registemailsender" element={<RegistEmailSender />} /> */}
                <Route path="resetpassword" element={<ResetEmailPassword />} />
                <Route path="emailchange" element={<EmailChange />} />
                <Route
                  path="emailsenderselect"
                  element={<EmailSenderSelect />}
                />
                <Route path="sentemails" element={<SentEmails />} />
                <Route path="emailsender" element={<EmailSender />} />
                <Route path="signupform" element={<SignUpForm />} />
                <Route path="memberlist" element={<MemberList />} />
                <Route path="memberinfo/:id" element={<MemberInfo />} />
                <Route path="memberdetail/:id" element={<MemberDetail />} />
                <Route path="memberdetail" element={<MemberDetail />} />
                <Route path="memberinfo" element={<MemberInfo />} />
                <Route
                  path="memberdetailconfirm"
                  element={<MemberDetailConfirm />}
                />
                {/* <Route path="" element={<EventCreate />} />
                <Route path="eventcreate/:id" element={<EventCreate />} /> */}
                <Route path="eventlist" element={<EventList />} />
                <Route path="eventselect" element={<EventSelect />} />
                <Route path="eventinfo" element={<EventInfo />} />
                <Route
                  path="eventinfo/:eventId/:eventState"
                  element={<EventInfo />}
                />
                <Route path="eventinfo/:eventId" element={<EventInfo />} />
                <Route path="eventdetail/:id" element={<EventDetail />} />
                <Route path="eventdetail" element={<EventDetail />} />
                <Route path="doubles" element={<Doubles />} />
                <Route
                  path="/eventcancel/:eventId/:eventMemberId"
                  element={<EventCancel />}
                />
                <Route
                  path="/participantemailsender/:id"
                  element={<ParticipantEmaiSender />}
                />
                <Route path="calendar" element={<Calendar />} />
                {/* 実装していない。 */}{" "}
                <Route path="createpost" element={<CreatePost />} />
                <Route path="postlist" element={<PostList />} />
                <Route path="postlist/:Id" element={<PostList />} />
                <Route path="email" element={<EmailSender />} />
                <Route path="datasend" element={<Datasend />} />
                <Route path="test" element={<Testdayo />} />
                <Route path="test/:eventId" element={<Testdayo />} />
                <Route path="/step1" element={<Step1 />} />
                <Route path="/step2" element={<Step2 />} />
                <Route path="/step3" element={<Step3 />} />
                <Route path="/submit" element={<FinalSubmit />} />
              </Routes>
            </MemberProvider>
          </EventProvider>
        </EventMembersProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
